import script from "./NewPaymentGatewayDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NewPaymentGatewayDialog.vue?vue&type=script&setup=true&lang=js"

import "./NewPaymentGatewayDialog.vue?vue&type=style&index=0&id=cdb9dfde&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdb9dfde"]])

export default __exports__